module.exports = __webpack_public_path__ + "static/media/mobile-gateway.4a98c97a.png";